import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgLockAgHeader = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="#0C6A93"
            d="M12 1q2.075 0 3.537 1.463Q17 3.926 17 6v2h1q.825 0 1.412.588Q20 9.176 20 10v10q0 .825-.588 1.412A1.93 1.93 0 0 1 18 22H6q-.824 0-1.412-.588A1.93 1.93 0 0 1 4 20V10q0-.825.588-1.412A1.93 1.93 0 0 1 6 8h1V6q0-2.075 1.463-3.537Q9.926 1 12 1m0 11a2.9 2.9 0 0 0-2.12.88A2.9 2.9 0 0 0 9 15q0 1.238.88 2.12A2.9 2.9 0 0 0 12 18a2.9 2.9 0 0 0 2.12-.88A2.9 2.9 0 0 0 15 15a2.9 2.9 0 0 0-.88-2.12A2.9 2.9 0 0 0 12 12m0-9q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 6v2h6V6q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 3"
        />
    </svg>
)
const ForwardRef = forwardRef(SvgLockAgHeader)
const Memo = memo(ForwardRef)
export default Memo
